import { SessionStorageKeys } from '@/shared/config'

export const setGoogleAuthRedirect = (path: string): void => {
  sessionStorage.setItem(SessionStorageKeys.googleAuthRedirect, path)
}

export const consumeGoogleAuthRedirect = (): string | undefined => {
  const path = sessionStorage.getItem(SessionStorageKeys.googleAuthRedirect)
  sessionStorage.removeItem(SessionStorageKeys.googleAuthRedirect)
  return path ?? undefined
}
